/**
 * Utilities for generating and managing slugs
 */

/**
 * Generates a unique slug for shifts that don't have one
 * @param {string} name - The name to base the slug on
 * @param {Array} existingItems - Array of existing items to check against (optional)
 * @returns {string} A unique slug
 */
export const generateUniqueSlug = (name, existingItems = []) => {
  // Base slug on the name
  const baseSlug = name
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '-') // Replace non-alphanumeric chars with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
  
  // Add timestamp to make it unique
  const timestamp = new Date().getTime();
  const randomStr = Math.random().toString(36).substring(2, 8);
  
  return `${baseSlug}-${timestamp}-${randomStr}`;
};

/**
 * Ensures all items in an array have slugs
 * @param {Array} items - Array of items to check
 * @param {string} nameField - The field to use for the name (default: 'name')
 * @returns {Array} Array with all items having slugs
 */
export const ensureSlugs = (items, nameField = 'name') => {
  if (!items || !items.length) return [];
  
  return items.map(item => {
    if (!item.slug) {
      const nameToUse = item[nameField] || item.shiftName || 'untitled';
      return {
        ...item,
        slug: generateUniqueSlug(nameToUse, items)
      };
    }
    return item;
  });
}; 